import React, { ReactNode } from 'react';
import { ReactComponent as ErrorTriangleIcon } from 'app/assets/img/error-triangle-icon.svg';

interface ErrMsgProps {
  children: ReactNode;
}

const ErrMsg = (props: ErrMsgProps) => {
  const { children } = props;
  return (
    <div
      className="d-flex align-items-center"
      style={{
        color: '#E92127',
        fontSize: 12,
        padding: '12px 16px',
        background: '#FFF4F4',
        borderRadius: 10,
      }}
    >
      <ErrorTriangleIcon style={{ marginRight: 8 }} />
      {children}
    </div>
  );
};

export default ErrMsg;
